import { formatCurrency, getCurrencySymbol } from '@angular/common'

export class GbBaseCurrency {
  public static getCurrencySymbol(
    value: number | string | null | undefined,
    currencyCode: string,
    locale: string,
    symbolFormat: 'wide' | 'narrow' = 'narrow',
  ): string | null {
    if (value || value === 0) {
      return formatCurrency(
        Number(value),
        locale,
        getCurrencySymbol(currencyCode, symbolFormat),
        currencyCode,
        +value % 1 === 0 ? '.0-0' : '.2-2',
      )
    }
    return null
  }
}
